<template lang="pug">
  v-switch(v-if="!readonly" :input-value="value === true || value === 'true'" :label="label" color="primary" @change="handleChange")
  v-layout.align-center(v-else-if="value === true || value === 'true'")
    v-icon.mr-1 check
    span.subheading.grey--text.text--darken-1 {{ label }}
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [Boolean, String],
      default: false,
    },
    valueId: {
      type: [Number, String],
      default: null,
    },
    attributeId: {
      type: Number,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleChange(value) {
      if (!value) {
        if (this.valueId) {
          this.$emit('delete', this.valueId);
        }
      } else {
        if (!this.valueId) {
          this.$emit('post', {attributeId: this.attributeId, value});
        } else {
          this.$emit('put', {valueId: this.valueId, value});
        }
      }
    }
  },
}
</script>
